import { API_BASE_URL } from '../config/api'
import { getAuthHeadersAsync } from '../utils/authUtils'

export interface FoodBankProfileInput {
  firstName?: string
  lastName?: string
  name: string
  street: string
  city: string
  state: string
  zipCode: string
  phone: string
  hours?: string
  capacity?: number
  description?: string
  latitude?: number
  longitude?: number
}

export async function upsertFoodBankProfile(profile: FoodBankProfileInput): Promise<any> {
  const authHeaders = await getAuthHeadersAsync(true)
  if (!authHeaders.Authorization) {
    throw new Error('No authentication token available. Please log in again.')
  }

  const response = await fetch(`${API_BASE_URL}/api/food-banks/profile`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeaders
    },
    body: JSON.stringify(profile)
  })

  const data = await response.json().catch(() => ({}))

  if (!response.ok) {
    throw new Error(data.error || 'Failed to update food bank profile')
  }

  return data.data
}


